import React from "react";
import ReactDOM from "react-dom";
import { Main } from "3.0";
import "focus-visible/dist/focus-visible";

ReactDOM.render(<Main />, document.getElementById("root"));
